const trimUrl = (url = '') => {
  if (url.endsWith('/')) {
    url = url.slice(0, -1);
  }
  if (url.endsWith('.html')) {
    url = url.slice(0, -5);
  }
  return url;
};

export const formatUrl = (url = '', base = 'https://www.klaviyo.com') => {
  const path = new URL(url, base).pathname;
  const internationalHomepageLangCodes = [
    '/de',
    '/es',
    '/fr',
    '/uk',
    '/it',
    '/au',
    '/sg',
    '/mx',
    '/br',
    // INTERNATIONAL_HOMEPAGE
  ];
  const internationalHomepage = internationalHomepageLangCodes.some((intlPath) => (intlPath === path) || (`${intlPath}/` === path));

  // trim any trailing slashes that might be there.
  const trimmedUrl = internationalHomepage ? url : trimUrl(url);
  if (!trimmedUrl.startsWith('http')) {
    const trimmedUrlWithSlash = `${trimmedUrl.startsWith('/') ? '' : '/'}${trimmedUrl}`;
    // prevent doubling the language prefix
    if (internationalHomepageLangCodes.some((langCode: string) => base.endsWith(langCode) && trimmedUrl.startsWith(langCode))) {
      return `${base}${trimmedUrlWithSlash.slice(3)}`;
    }
    return `${base}${trimmedUrlWithSlash}`;
  }

  return trimmedUrl.replace('marketinguiproduction.gatsbyjs.io', 'www.klaviyo.com');
};

export const isSeoExcludedPath = (uri = '') => {
  const exclusions = [
    '/404',
    '/grow/',
    '/de/grow/',
    '/es/grow/',
    '/fr/grow/',
    '/uk/grow/',
    '/lp/',
    '/de/lp/',
    '/es/lp/',
    '/fr/lp/',
    '/uk/lp/',
    '/it/grow/',
    '/it/lp/',
    '/au/grow/',
    '/au/lp/',
    '/sg/grow/',
    '/sg/lp/',
    '/mx/grow/',
    '/mx/lp/',
    '/br/grow/',
    '/br/lp/',
    // SEO_EXCLUSIONS
  ];

  return exclusions.some((exclude) => uri.startsWith(exclude));
};
